import {
    filter,
    distinctUntilChanged,
    // pairwise,
    // tap,
    scan,
    map,
} from 'rxjs/operators';

import EditBox from '@/components/Dashboard/edit/EditBox';
import InputField from '@components/Dashboard/edit/InputField';
import Dropdown from '@/components/Common/DropdownBox/defaultDropdown';
import SelectedBox from '@/components/Common/DropdownBox/selectedBox';
// import Checkbox from '@/components/Common/Checkbox';
import SelectStream from './SelectStream';
import { SchedulesSettings } from './SchedulesSettings';

import { ExportDataService } from '@/services';

import {
    upperHead,
    isValueExist,
    // generateId,
    listIncludes,
} from '@/utils/utils';

import * as S from './style';

import {
    TRANFER_TYPE,
    FREQUENCY,
    SCHEDULES,
    EDIT_TRANSFER,
    GSS_SELECTED,
    DUPLICATE_TRANSFER,
    CREATE_TRANSFER,
    DATA_TRANSFER_LIST_TYPE,
} from './';
import { TRANSFER_TYPES } from '@/utils/consts';
import { DS_DEST_ICONS_MAP } from '../table';
import withHMR from '@/utils/withHMR';

const FREQUENCY_OPTIONS = [
    {
        value: 8,
        display_name: '8h',
    },
    {
        value: 24,
        display_name: '24h',
    },
];

const { S3, API } = TRANSFER_TYPES;

const ALLOWED_KEYS_AT_DUPLICATE = {
    [S3]: ['s3_bucket_name', 's3_bucket_path', 's3_bucket_region'],
};

export const CreateTransfer = {
    name: 'CreateTransfer',
    props: {
        formData: {
            type: Array,
            default: R.always([]),
        },
        valueMap: {
            type: Object,
            default: R.always({
                [TRANFER_TYPE]: '',
                [FREQUENCY]: '',
                [GSS_SELECTED]: '',
            }),
        },
        dropdownMap: {
            type: Object,
            default: R.always({
                [TRANFER_TYPE]: false,
                [FREQUENCY]: false,
            }),
        },
        page: String,
        selectedItem: {
            type: Object, // DATA_TRANSFER_LIST_TYPE
            default: () => ({}),
        },
        transferOptions: {
            type: Array,
            default: R.always([]),
        },
        transferList: {
            type: Array,
            default: R.always([]),
        },
        streamType: String,
    },
    computed: {
        isDisabled() {
            return (
                this.page === EDIT_TRANSFER || this.page === DUPLICATE_TRANSFER
            );
        },
        transferName() {
            return this.valueMap[TRANFER_TYPE]?.name;
        },
        isSftp() {
            return this.transferName === 'SFTP';
        },
        shouldRenderName() {
            return !listIncludes(['SFTP'], this.transferName);
        },
    },
    methods: {
        setValue(key, value) {
            this.$emit('setValueMap', R.assoc(key, value, this.valueMap));
        },
        setDropdown(key, value) {
            this.$emit('setDropdownMap', R.assoc(key, value, this.dropdownMap));
        },
        renderEachForm(item) {
            const { title = '', key = '', value, order } = item;

            const index = R.findIndex(R.propEq('order', order), this.formData);

            const onInput = (v) =>
                this.$emit(
                    'setFormData',
                    R.assocPath([index, 'value'], v, this.formData)
                );

            const allowedDuplicateKeys =
                ALLOWED_KEYS_AT_DUPLICATE[this.valueMap[TRANFER_TYPE].name];

            const _isDisabled =
                this.page === DUPLICATE_TRANSFER && allowedDuplicateKeys
                    ? !allowedDuplicateKeys.includes(key)
                    : this.isDisabled;

            return (
                <EditBox
                    title={this.translateOr(
                        `EXPORT_DATA.form_label_${key}`,
                        upperHead(title)
                    )}
                    isFocus={true}
                >
                    <S.InputWrapper>
                        <InputField
                            type={'text'}
                            value={value || ''}
                            onInput={onInput}
                            errorText={this.validateInput(item)}
                            errorDirection="right"
                            autocomplete={
                                key.includes('password')
                                    ? 'new-password'
                                    : 'nope'
                            }
                            id={key}
                            disabled={_isDisabled}
                            cleaner={R.identity}
                        />
                        {key === 'schema' && (
                            <S.HelpText
                                domPropsInnerHTML={this.$t(
                                    'EXPORT_DATA.description_schema'
                                )}
                            ></S.HelpText>
                        )}
                    </S.InputWrapper>
                </EditBox>
            );
        },
        renderTransferOptions() {
            const {
                valueMap,
                dropdownMap,
                setValue,
                setDropdown,
                transferOptions,
                isDisabled,
            } = this;

            const key = TRANFER_TYPE;

            const value = valueMap[key];
            const isVisible = dropdownMap[key];
            const setKeyDropdown = (v) => setDropdown(key, v);
            const setKeyValue = (v) => setValue(key, v);

            const _translator = ({ name, custom, icon }) => {
                icon = icon || DS_DEST_ICONS_MAP[name];
                return (
                    <S.DestinationWrapper>
                        {typeof icon === 'string' ? (
                            <img width="24px" height="24px" src={icon} />
                        ) : (
                            icon && <icon />
                        )}
                        <span>
                            {custom
                                ? `${name} (custom)`
                                : R.replace(' v2', '', name)}
                        </span>
                    </S.DestinationWrapper>
                );
            };

            const boxProps = {
                attrs: {
                    selectedOption: value,
                    translator: _translator,
                    isMultiple: false,
                    id: `adverity-dropdown-${key}`,
                    disabled: isDisabled,
                },
                on: {
                    click: () => setKeyDropdown(!isVisible),
                },
            };

            const dropdownProps = {
                attrs: {
                    isVisible: isVisible,
                    value: value,
                    optionList: transferOptions,
                    translator: _translator,
                    showSelected: true,
                    width: (() => {
                        if (isVisible) {
                            const el$ = document.getElementById(
                                `adverity-dropdown-${key}`
                            );

                            if (el$) {
                                const { width = 320 } =
                                    el$.getBoundingClientRect();
                                return width;
                            }
                        }

                        return 320;
                    })(),
                },
                on: {
                    confirm: (v) => {
                        setKeyValue(v);
                        setKeyDropdown(false);
                    },
                },
            };
            return (
                <S.ConfigWrapper>
                    <S.ConfigTitle>
                        {this.$t('EXPORT_DATA.panel_sub_title_configuration')}
                    </S.ConfigTitle>
                    {/*<S.ConfigSubTitle>*/}
                    {/*    {this.$t('EXPORT_DATA.panel_description_configuration')}*/}
                    {/*</S.ConfigSubTitle>*/}
                    <EditBox
                        title={this.$t('EXPORT_DATA.form_label_type')}
                        isFocus
                    >
                        <S.DropdownWrapper>
                            <SelectedBox {...boxProps} />
                            <Dropdown {...dropdownProps} />
                        </S.DropdownWrapper>
                    </EditBox>
                    {this.renderOptionsDesc()}
                </S.ConfigWrapper>
            );
        },
        observeTransferOption$({ hasAlreadySelectedTransferType }) {
            const { generateWatchNew$: gen$, fetchFormsV2 } = this;

            const trasnferOptionsType$ = gen$('valueMap.transferType').pipe(
                filter(R.identity),
                distinctUntilChanged(R.equals),
                scan(
                    (acc, value) => {
                        return {
                            count: acc.count + 1,
                            value,
                        };
                    },
                    { count: 0, value: undefined }
                ),
                filter(({ count }) => {
                    const isBackFromSelectSource =
                        count === 1 &&
                        hasAlreadySelectedTransferType &&
                        this.page == CREATE_TRANSFER;

                    return !isBackFromSelectSource;
                }),
                map(R.prop('value'))
            );

            this.$subscribeTo(trasnferOptionsType$, fetchFormsV2);
        },
        async fetchFormsV2({ name = '' }) {
            if (name.includes('Google Sheets')) {
                const gssWritableAssetsList =
                    await ExportDataService.getGssWithWriteAccess();

                this.$emit('setFormData', gssWritableAssetsList);

                const sheetId = R.path(
                    [
                        'selectedItem',
                        'connectionConfiguration',
                        'spreadsheet_id',
                    ],
                    this
                );

                if (sheetId) {
                    const sheetValue = gssWritableAssetsList.find(
                        R.propEq('spreadsheetId', sheetId)
                    );

                    if (sheetValue) {
                        this.setValue(GSS_SELECTED, sheetValue);
                    }
                }
                return;
            } else if (name === 'SFTP') {
                this.$emit('setFormData', []);

                return;
            }

            const formData = await ExportDataService.getSettingListV2(name);

            this.$emit('setFormData', formData || []);
        },
        renderGSS() {
            const transferOptions = this.formData;
            const selectedValue = this.valueMap[GSS_SELECTED];
            const isVisible = this.dropdownMap[GSS_SELECTED];

            const setKeyDropdown = (v) => this.setDropdown(GSS_SELECTED, v);
            const setKeyValue = (v) => this.setValue(GSS_SELECTED, v);
            const onInput = (v) =>
                this.$emit(
                    'setFormData',
                    R.assocPath([0, 'value'], v, this.formData)
                );

            const boxProps = {
                attrs: {
                    selectedOption: selectedValue,
                    translator: R.prop('name'),
                    isMultiple: false,
                    id: `gss-selected-${GSS_SELECTED}`,
                    disabled: this.isDisabled,
                },
                on: {
                    click: () => setKeyDropdown(!isVisible),
                },
            };

            const dropdownProps = {
                attrs: {
                    isVisible: isVisible,
                    value: selectedValue,
                    optionList: transferOptions,
                    translator: R.prop('name'),
                    showSelected: true,
                    width: (() => {
                        if (isVisible) {
                            const el$ = document.getElementById(
                                `gss-selected-${GSS_SELECTED}`
                            );

                            if (el$) {
                                const { width = 320 } =
                                    el$.getBoundingClientRect();
                                return width;
                            }
                        }

                        return 320;
                    })(),
                },
                on: {
                    confirm: (v) => {
                        setKeyValue(v);
                        setKeyDropdown(false);
                        onInput(v);
                    },
                },
            };

            return (
                <EditBox
                    // title={this.translateOr(
                    //     `EXPORT_DATA.form_label_${GSS_SELECTED}`,
                    //     // upperHead(title)
                    //     upperHead('Google Spreadsheet')
                    // )}
                    title={'Google Spreadsheet'}
                    isFocus={true}
                >
                    <S.DropdownWrapper>
                        <SelectedBox {...boxProps} />
                        <Dropdown {...dropdownProps} />
                    </S.DropdownWrapper>
                </EditBox>
            );
        },
        renderFormData() {
            const selectedTransferType = this.valueMap[TRANFER_TYPE];
            const name = selectedTransferType?.name ?? '';
            if (name.includes('Google Sheets')) {
                return (
                    <S.ConfigWrapper>
                        {this.renderGSS()}
                        <S.ConfigBottomDescription>
                            {this.$t(
                                'EXPORT_DATA.panel_description_configuration_end'
                            )}
                        </S.ConfigBottomDescription>
                    </S.ConfigWrapper>
                );
            } else if (name === 'SFTP') {
                return null;
            }

            return (
                <S.ConfigWrapper>
                    {this.formData.map(this.renderEachForm)}
                    <S.ConfigBottomDescription>
                        {this.$t(
                            'EXPORT_DATA.panel_description_configuration_end'
                        )}
                    </S.ConfigBottomDescription>
                </S.ConfigWrapper>
            );
        },
        renderFrequency() {
            const { valueMap, dropdownMap, setValue, setDropdown, isDisabled } =
                this;

            const selectedTransferType = valueMap[TRANFER_TYPE];
            const name = selectedTransferType?.name;

            if (name === 'SFTP') {
                return null;
            }

            const key = FREQUENCY;

            const value = valueMap[key];
            const isVisible = dropdownMap[key];
            const setKeyDropdown = (v) => setDropdown(key, v);
            const setKeyValue = (v) => setValue(key, v);

            const boxProps = {
                attrs: {
                    selectedOption: value,
                    translator: R.propOr('-', 'display_name'),
                    isMultiple: false,
                    id: `adverity-dropdown-${key}`,
                    disabled: isDisabled,
                },
                on: {
                    click: () => {
                        setKeyDropdown(!isVisible);

                        if (!isVisible && !isDisabled) {
                            const el = this.$refs['frequency-dropdown'].$el;

                            setTimeout(() => {
                                el && el.scrollIntoView(false);
                            }, 0);
                        }
                    },
                },
            };

            const dropdownProps = {
                attrs: {
                    isVisible: isVisible,
                    value,
                    optionList: FREQUENCY_OPTIONS,
                    translator: R.propOr('-', 'display_name'),
                    showSelected: true,
                    width: (() => {
                        if (isVisible) {
                            const el$ = document.getElementById(
                                `adverity-dropdown-${key}`
                            );

                            if (el$) {
                                const { width = 320 } =
                                    el$.getBoundingClientRect();
                                return width;
                            }
                        }

                        return 320;
                    })(),
                },
                on: {
                    confirm: (v) => {
                        setKeyValue(v);
                        setKeyDropdown(false);
                    },
                },
            };
            return (
                <S.ConfigWrapper>
                    <S.ConfigTitle>
                        {this.$t('EXPORT_DATA.form_label_frequency')}
                    </S.ConfigTitle>
                    <S.ConfigSubTitle>
                        {this.$t('EXPORT_DATA.panel_description_frequency')}
                    </S.ConfigSubTitle>
                    <EditBox
                        title={this.$t('EXPORT_DATA.form_label_frequency')}
                        isFocus
                    >
                        <S.DropdownWrapper>
                            <SelectedBox {...boxProps} />
                            <Dropdown
                                {...dropdownProps}
                                ref="frequency-dropdown"
                            />
                        </S.DropdownWrapper>
                    </EditBox>
                </S.ConfigWrapper>
            );
        },
        renderSchedules() {
            const { valueMap, setValue } = this;
            const schedules = valueMap[SCHEDULES];

            const componentProps = {
                props: { value: schedules },
                on: {
                    change: (schedules) => {
                        setValue(SCHEDULES, schedules);
                    },
                },
            };

            return <SchedulesSettings {...componentProps} />;
        },
        renderName() {
            if (!this.shouldRenderName) {
                return null;
            }

            const value = this.valueMap['name'];
            const onInput = (v) =>
                this.$emit('setValueMap', R.assoc('name', v, this.valueMap));

            return (
                <S.ConfigWrapper>
                    <S.ConfigTitle>
                        {this.$t('EXPORT_DATA.form_label_name')}
                    </S.ConfigTitle>
                    <EditBox
                        title={this.$t('EXPORT_DATA.form_label_name')}
                        isFocus={true}
                    >
                        <S.InputWrapper>
                            <InputField
                                type="text"
                                value={value || ''}
                                onInput={onInput}
                                errorText={
                                    !value
                                        ? this.$t('COMMON.field_required')
                                        : ''
                                }
                                errorDirection="right"
                                disabled={this.page === EDIT_TRANSFER}
                                maxLength={50}
                                cleaner={R.replace(/[^a-z_]+/g, '')}
                            />
                            <S.HelpText
                                domPropsInnerHTML={this.$t(
                                    'EXPORT_DATA.description_name'
                                )}
                            ></S.HelpText>
                        </S.InputWrapper>
                    </EditBox>
                </S.ConfigWrapper>
            );
        },
        renderOptionsDesc() {
            if (this.isSftp) {
                return <div>{this.$t('EXPORT_DATA.custom_contact_desc')}</div>;
            }
        },
        validateInput(item) {
            const { value, required, validations = [] } = item;
            let messages = [];
            if (required && !value) {
                messages.push(this.$t('COMMON.field_required'));
            }
            if (validations?.length > 0) {
                for (const { type, regex, message } of validations) {
                    const regExp = new RegExp(regex);
                    const expectedTestResult = type === 'allow'; // 'allow' means test should always true / 'deny' means test should always false
                    if (regExp.test(value) !== expectedTestResult) {
                        messages.push(this.$t(message));
                    }
                }
            }

            if (messages.length > 0) {
                return messages.join('\n');
            } else {
                return '';
            }
        },
    },
    mounted() {
        if (!isValueExist(this.transferOptions)) return;

        const selectedTransferType = this.valueMap[TRANFER_TYPE];

        const selected = isValueExist(this.selectedItem)
            ? R.compose(
                  (name) =>
                      R.find(R.propEq('name', name), this.transferOptions),
                  R.path(['dataTransferConfig', 'destination_connector_type'])
              )(this.selectedItem)
            : isValueExist(selectedTransferType)
            ? selectedTransferType
            : R.head(this.transferOptions);

        this.setValue(TRANFER_TYPE, selected);

        this.observeTransferOption$({
            hasAlreadySelectedTransferType: isValueExist(selectedTransferType),
        });
    },
    render() {
        return (
            <S.CreateTransferWrapper
                ref="wrapper"
                class="ds-create-transfer-wrapper"
            >
                {this.renderName()}
                {this.renderTransferOptions()}
                {this.renderFormData()}
                {(this.page === EDIT_TRANSFER ||
                    this.page === DUPLICATE_TRANSFER) && (
                    <SelectStream
                        streamType={this.streamType}
                        page={this.page}
                        on={{
                            setStreamType: (value) => (this.streamType = value),
                        }}
                    />
                )}
                {/* {this.renderFrequency()} */}
                {this.valueMap?.transferType?.name !== API && this.renderSchedules()}
            </S.CreateTransferWrapper>
        );
    },
};

export default withHMR(module, CreateTransfer, CreateTransfer.name);
